import React, { createContext, useContext, useReducer } from 'react'

// This pattern can be found here: https://kentcdodds.com/blog/how-to-use-react-context-effectively

const defaultState = {
    showUploadModal: false,
    isLoading: false,
    requiresListUpdate: true,
    visualisationsList: []
}

function visualisationsReducer(state, action) {
    switch (action.type) {

        case 'closeModal':
            return {
                ...state,
                file: null,
                isLoading: false,
                requiresListUpdate: true
            }
        
        case 'updateVisualisationsList': {
            return {
                ...state,
                visualisationsList: action.payload,
                requiresListUpdate: false
            }
        }

        case 'requestListUpdate': {
            return {
                ...state,
                requiresListUpdate: true
            }
        }
    
        default:
            throw new Error(`Unhandled action type: ${action.type}`)
    }
}

const VisualisationsStateContext = createContext(defaultState)
const VisualisationsDispatchContext = createContext(visualisationsReducer)

function VisualisationsProvider({ children }) {
    const [ state, dispatch ] = useReducer(visualisationsReducer, defaultState)
    return (
        <VisualisationsStateContext.Provider value={state} >
            <VisualisationsDispatchContext.Provider value={dispatch} >
                { children }
            </VisualisationsDispatchContext.Provider>
        </VisualisationsStateContext.Provider>
    )
}

function useVisualisationsState() {
    const context = useContext(VisualisationsStateContext)

    if (context === undefined) {
        throw new Error('useVisualisationsDispatch must be used within a VisualisationsProvider')
    }

    return context
}

function useVisualisationsDispatch() {
    const dispatch = useContext(VisualisationsDispatchContext)

    if (dispatch === undefined) {
        throw new Error('useVisualisationsDispatch must be used within a VisualisationsProvider')
    }

    // Actions Creators
    const requiresVisualisationListUpdate = () => dispatch({ type: 'requestListUpdate' })

    const closeModal = () => dispatch({ type: 'closeModal' })

    const updateVisualisationsList = (visList) => dispatch({ type: 'updateVisualisationsList', payload: visList  })

    return {
        dispatch,
        requiresVisualisationListUpdate,
        closeModal,
        updateVisualisationsList
    }
}

export { VisualisationsProvider, useVisualisationsState, useVisualisationsDispatch }
